/**
 * Canonicalizes locale identifiers for comparison across account, player, and
 * content-availability boundaries without applying syntax validation or a
 * default locale.
 */
export function canonicalizeLocale(locale: string | null | undefined): string {
  return (locale ?? '').trim().replace(/_/g, '-').toLowerCase();
}
